const MobileAppStyles = () => {
  return (
    <style jsx>{`
      .mobile-app-page {
        font-family:
          -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }

      /* Hero Section */
      .mobile-app-hero {
        padding: 120px 0 80px;
      }

      .hero-content {
        position: relative;
        z-index: 1;
      }

      .breadcrumb-nav {
        margin-bottom: 40px;
      }

      .breadcrumb {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 50px;
        padding: 10px 20px;
        display: inline-flex;
      }

      .breadcrumb-item a {
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
      }

      .breadcrumb-item.active {
        color: #ffd700;
      }

      .min-vh-85 {
        min-height: 85vh;
      }

      /* Why Mobile Section */
      .why-mobile-section {
        padding: 100px 0;
        background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
      }

      /* Comparison Table */
      .comparison-table {
        background: white;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 20px 40px rgba(10, 36, 88, 0.1);
      }

      .table-header {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        padding: 20px 30px;
        font-size: 1.1rem;
      }

      .table-row {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr;
        padding: 20px 30px;
        border-bottom: 1px solid #f1f5f9;
        align-items: center;
        transition: all 0.3s ease;
      }

      .table-row:hover {
        background: #f8fafc;
      }

      .table-row:last-child {
        border-bottom: none;
      }

      .feature-col,
      .website-col,
      .app-col {
        padding: 10px;
      }

      .badge {
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 0.9rem;
        display: inline-block;
      }

      /* App Types Section */
      .app-types-section {
        padding: 100px 0;
        background: white;
      }

      .app-type-card {
        background: white;
        border-radius: 20px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(10, 36, 88, 0.08);
        transition: all 0.4s ease;
        border: 1px solid rgba(10, 36, 88, 0.1);
        position: relative;
        overflow: hidden;
      }

      .app-type-card::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(
          90deg,
          #0a2458 0%,
          #1a3b8a 50%,
          #ffd700 100%
        );
      }

      .app-icon {
        font-size: 48px;
        margin-bottom: 20px;
        width: 80px;
        height: 80px;
        background: rgba(10, 36, 88, 0.1);
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .app-type-card h3 {
        color: #0a2458;
        font-size: 1.5rem;
        margin-bottom: 15px;
        font-weight: 700;
      }

      .app-desc {
        color: #0a2458;
        font-size: 0.95rem;
        line-height: 1.6;
        margin-bottom: 25px;
      }

      .app-details {
        margin-bottom: 20px;
      }

      .detail-section {
        margin-bottom: 15px;
      }

      .detail-section strong {
        display: block;
        color: #0a2458;
        margin-bottom: 8px;
        font-size: 0.9rem;
      }

      .detail-section ul {
        padding-left: 20px;
        margin: 0;
      }

      .detail-section li {
        color: #0a2458;
        font-size: 0.85rem;
        margin-bottom: 5px;
        line-height: 1.4;
      }

      .example-box {
        background: rgba(10, 36, 88, 0.05);
        border-left: 4px solid #ffd700;
        padding: 15px;
        border-radius: 8px;
        font-size: 0.85rem;
        color: #0a2458;
        line-height: 1.5;
      }

      .example-box strong {
        color: #0a2458;
      }

      /* Platform Section */
      .platform-section {
        padding: 100px 0;
        background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
      }

      .platform-card {
        background: white;
        border-radius: 20px;
        padding: 30px;
        height: 100%;
        border: 2px solid #e2e8f0;
        position: relative;
        transition: all 0.3s ease;
      }

      .platform-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      }

      .platform-card.native {
        border-color: #10b981;
      }

      .platform-card.cross-platform {
        border-color: #3b82f6;
      }

      .platform-card.highlighted {
        border-color: #0a2458;
      }

      .recommended-badge {
        position: absolute;
        top: -12px;
        right: 20px;
        background: #0a2458;
        color: white;
        padding: 6px 20px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
      }

      .card-header {
        margin-bottom: 25px;
      }

      .platform-icon {
        font-size: 48px;
        margin-bottom: 15px;
      }

      .platform-card h3 {
        color: #0a2458;
        font-size: 1.75rem;
        margin-bottom: 8px;
        font-weight: 700;
      }

      .platform-subtitle {
        color: #0a2458;
        font-size: 1rem;
      }

      .pros-cons {
        margin-bottom: 25px;
      }

      .pros h4,
      .cons h4 {
        font-size: 1.1rem;
        margin-bottom: 10px;
      }

      .pros h4 {
        color: #10b981;
      }

      .cons h4 {
        color: #ef4444;
      }

      .pros ul,
      .cons ul {
        padding-left: 20px;
        margin-bottom: 20px;
      }

      .pros li,
      .cons li {
        color: #0a2458;
        margin-bottom: 8px;
        line-height: 1.4;
      }

      .best-for {
        background: rgba(10, 36, 88, 0.05);
        padding: 20px;
        border-radius: 12px;
      }

      .best-for h4 {
        color: #0a2458;
        margin-bottom: 10px;
        font-size: 1.1rem;
      }

      .best-for ul {
        padding-left: 20px;
        margin: 0;
      }

      .best-for li {
        color: #0a2458;
        margin-bottom: 5px;
        font-size: 0.9rem;
      }

      .recommendation-box {
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        border-radius: 20px;
        padding: 40px;
        color: white;
        margin-top: 40px;
        display: flex;
        align-items: flex-start;
        gap: 30px;
      }

      .recommendation-icon {
        font-size: 48px;
        flex-shrink: 0;
      }

      .recommendation-content h3 {
        font-size: 1.75rem;
        margin-bottom: 15px;
      }

      .recommendation-content p {
        font-size: 1.1rem;
        line-height: 1.6;
        margin-bottom: 25px;
        opacity: 0.9;
      }

      .stats-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
      }

      .stat {
        text-align: center;
        background: rgba(255, 255, 255, 0.1);
        padding: 20px;
        border-radius: 12px;
        backdrop-filter: blur(10px);
      }

      .stat-value {
        font-size: 2.5rem;
        font-weight: 700;
        color: #ffd700;
        margin-bottom: 5px;
      }

      .stat-label {
        font-size: 0.9rem;
        opacity: 0.9;
      }

      /* Process Section */
      .process-section {
        padding: 100px 0;
        background: white;
      }

      .process-timeline {
        max-width: 900px;
        margin: 0 auto;
        position: relative;
      }

      .process-timeline::before {
        content: "";
        position: absolute;
        left: 60px;
        top: 0;
        bottom: 0;
        width: 2px;
        background: linear-gradient(to bottom, #0a2458, #1a3b8a, #ffd700);
      }

      .process-step {
        display: flex;
        gap: 30px;
        margin-bottom: 40px;
        position: relative;
      }

      .step-number {
        width: 120px;
        height: 120px;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.5rem;
        font-weight: 700;
        flex-shrink: 0;
        box-shadow: 0 10px 25px rgba(10, 36, 88, 0.2);
        position: relative;
        z-index: 1;
      }

      .step-content {
        flex: 1;
        background: #f8fafc;
        padding: 30px;
        border-radius: 20px;
        border: 1px solid #e2e8f0;
        transition: all 0.3s ease;
      }

      .process-step:hover .step-content {
        background: white;
        transform: translateX(10px);
        box-shadow: 0 15px 35px rgba(10, 36, 88, 0.1);
        border-color: #0a2458;
      }

      .step-header {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 15px;
      }

      .step-header h3 {
        color: #0a2458;
        font-size: 1.5rem;
        margin: 0;
        font-weight: 700;
      }

      .step-duration {
        color: #0a2458;
        font-size: 1rem;
        background: white;
        padding: 5px 15px;
        border-radius: 20px;
        border: 1px solid #e2e8f0;
      }

      .step-desc {
        color: #0a2458;
        font-size: 1.1rem;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .step-points {
        padding-left: 20px;
        margin: 0;
      }

      .step-points li {
        color: #0a2458;
        margin-bottom: 10px;
        line-height: 1.5;
      }

      /* Technologies Section */
      .technologies-section {
        padding: 100px 0;
        background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
      }

      .tech-card {
        background: white;
        border-radius: 20px;
        padding: 30px;
        height: 100%;
        border: 2px solid #e2e8f0;
        position: relative;
        transition: all 0.3s ease;
      }

      .tech-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      }

      .tech-card.primary {
        border-color: #0a2458;
      }

      .tech-badge {
        position: absolute;
        top: -12px;
        right: 20px;
        background: #0a2458;
        color: white;
        padding: 6px 20px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
      }

      .tech-header {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;
      }

      .tech-icon {
        font-size: 40px;
      }

      .tech-card h3 {
        color: #0a2458;
        font-size: 1.5rem;
        margin: 0;
        font-weight: 700;
      }

      .tech-features {
        padding-left: 0;
        margin-bottom: 20px;
      }

      .tech-features li {
        list-style: none;
        color: #0a2458;
        margin-bottom: 10px;
        font-size: 0.95rem;
        padding-left: 0;
      }

      .native-details {
        margin-bottom: 20px;
      }

      .native-platform {
        margin-bottom: 20px;
      }

      .native-platform h4 {
        color: #0a2458;
        font-size: 1.2rem;
        margin-bottom: 10px;
      }

      .native-platform ul {
        padding-left: 20px;
        margin: 0;
      }

      .native-platform li {
        color: #0a2458;
        font-size: 0.9rem;
        margin-bottom: 5px;
      }

      .tech-perfect {
        background: rgba(10, 36, 88, 0.05);
        padding: 15px;
        border-radius: 12px;
        color: #0a2458;
        font-size: 0.95rem;
      }

      /* Final CTA Section */
      .final-cta-section {
        padding: 100px 0;
        background: linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%);
        position: relative;
        overflow: hidden;
      }

      .final-cta-section::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
          radial-gradient(
            circle at 20% 80%,
            rgba(255, 215, 0, 0.15) 0%,
            transparent 50%
          ),
          radial-gradient(
            circle at 80% 20%,
            rgba(255, 255, 255, 0.05) 0%,
            transparent 50%
          );
      }

      .cta-card {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        padding: 40px 30px;
        text-align: center;
        height: 100%;
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;
        position: relative;
        z-index: 1;
      }

      .cta-card:hover {
        transform: translateY(-10px);
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
        background: white;
      }

      .cta-icon {
        font-size: 48px;
        margin-bottom: 20px;
      }

      .cta-card h3 {
        color: #0a2458;
        font-size: 1.5rem;
        margin-bottom: 15px;
        font-weight: 700;
      }

      .cta-card p {
        color: #0a2458;
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 25px;
      }

      .cta-btn {
        width: 100%;
        padding: 16px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 1rem;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }

      .cta-btn.primary {
        background: linear-gradient(135deg, #ffd700 0%, #ffc107 100%);
        color: #0a2458;
      }

      .cta-btn.primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(255, 215, 0, 0.3);
      }

      .cta-btn.secondary {
        background: transparent;
        color: #0a2458;
        border: 2px solid #0a2458;
      }

      .cta-btn.secondary:hover {
        background: rgba(10, 36, 88, 0.05);
      }

      .contact-info {
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        padding: 40px;
        margin-top: 60px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        position: relative;
        z-index: 1;
      }

      .info-item {
        display: flex;
        align-items: center;
        gap: 15px;
      }

      .info-icon {
        font-size: 32px;
        color: #ffd700;
      }

      .info-label {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.9rem;
        margin-bottom: 5px;
      }

      .info-value {
        color: white;
        font-size: 1.1rem;
        font-weight: 600;
      }

      /* Responsive Design */
      @media (max-width: 768px) {
        .mobile-app-hero {
          padding: 80px 0 60px;
        }

        .min-vh-85 {
          min-height: auto;
        }

        .table-header,
        .table-row {
          grid-template-columns: 1fr;
          gap: 10px;
        }

        .process-timeline::before {
          left: 40px;
        }

        .step-number {
          width: 80px;
          height: 80px;
          font-size: 1.75rem;
        }

        .recommendation-box {
          flex-direction: column;
          text-align: center;
          gap: 20px;
        }

        .stats-grid {
          grid-template-columns: 1fr;
        }

        .contact-info .row {
          gap: 20px;
        }
      }

      @media (max-width: 576px) {
        .app-type-card {
          padding: 20px;
        }

        .platform-card {
          padding: 20px;
        }

        .cta-card {
          padding: 30px 20px;
        }

        .step-content {
          padding: 20px;
        }
      }
    `}</style>
  );
};

export default MobileAppStyles;
